"use client";

import {
  spacing,
  fonts,
  fontSizes,
  colors,
} from "@softmax/design-system/tokens.stylex";

import { useState, useEffect } from "react";
import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";

type StalledHelpProps = Readonly<{
  afterMs: number;
  summary: string;
  children: ReactNode;
}>;

export function StalledHelp({ afterMs, summary, children }: StalledHelpProps) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => setOpen(true), afterMs);
    return () => clearTimeout(id);
  }, [afterMs]);
  return (
    <details
      data-stalled-help
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
      {...stylex.props(localStyles.help)}
    >
      <summary {...stylex.props(localStyles.helpSummary)}>{summary}</summary>
      <div {...stylex.props(localStyles.helpContent)}>{children}</div>
    </details>
  );
}

const localStyles = stylex.create({
  help: {
    fontFamily: fonts.sans,
    fontSize: fontSizes.label,
    lineHeight: 1.45,
    color: colors.foreground,
  },
  helpSummary: { cursor: "pointer", fontWeight: 500 },
  helpContent: {
    display: "flex",
    flexDirection: "column",
    gap: spacing.space6,
    marginTop: spacing.space8,
  },
});
